import ViewPolicy from './pages/ViewPolicy.vue';
import SavePolicy from './pages/SavePolicy.vue';
import EditPolicy from './pages/EditPolicy.vue';

export default {
  'view-policy': ViewPolicy,
  'save-policy': SavePolicy,
  'edit-policy': EditPolicy,
};
